import React from 'react'
import { getIcon } from '@next-nx/utils/icons'
import { MenuItemType } from '@next-nx/utils/types'
import styles from './LandingReassurance.module.sass'


interface Props {
  item: MenuItemType | undefined
  className?: string
}

const LandingReassurance = (props: Props) => {

  const { 
    item = undefined,
    className = '',
  } = props

  return item?.children && item?.children?.edges.length > 0 ? (
    <div className={`${styles.landingReassurance} ${className}`}>
      {item.children.edges.map(x => (
        <div className={styles.item} key={`landing-reassurance-${x.node.pk}`}>
          <span className={styles.itemIcon}>
            {getIcon(x.node.style)}
          </span>
          {!!x.node.description && <div className={styles.itemLabel} dangerouslySetInnerHTML={{ __html: x.node.description }} />}
        </div>
      ))}
    </div>
  ) : <></>
}

export default LandingReassurance
